import React from 'react'
import { TaskCard, TaskColumn, TaskBoardType } from '../../types/task-board'

interface TaskCardMoveColumnProps {
  card: TaskCard
  currentColumnId: string
  board: TaskBoardType
  onMoveCard: (cardId: string, sourceColumnId: string, destinationColumnId: string) => Promise<void>
}

export const TaskCardMoveColumn: React.FC<TaskCardMoveColumnProps> = ({ card, currentColumnId, board, onMoveCard }) => {
  const handleMove = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newColumnId = e.target.value
    if (newColumnId !== currentColumnId) {
      onMoveCard(card.id, currentColumnId, newColumnId)
    }
  }

  return (
    <div style={{ border: '1px solid #e9ecef', borderRadius: '5px', marginBottom: '20px', overflow: 'hidden' }}>
      <div style={{ backgroundColor: '#f8f9fa', padding: window.innerWidth < 768 ? '8px 10px' : '10px 15px', borderBottom: '1px solid #e9ecef' }}>
        <h4 style={{ fontSize: window.innerWidth < 768 ? '15px' : '16px', fontWeight: 600, margin: 0 }}>
          Przenieś do kolumny
        </h4>
      </div>
      <div style={{ padding: window.innerWidth < 768 ? '10px' : '15px' }}>
        <select
          value={currentColumnId}
          onChange={handleMove}
          style={{ width: '100%', padding: '8px 10px', fontSize: '14px', borderRadius: '4px', border: '1px solid #ced4da', boxSizing: 'border-box' }}
        >
          {board.columns.map(col => (
            <option key={col.id} value={col.id}>{col.title}</option>
          ))}
        </select>
      </div>
    </div>
  )
}
